// src/utils/DeviceNameMapper.js

// Classe responsable de la logique "ID boîtier -> nom lisible"
export class DeviceNameMapper {
  constructor(deviceType, deviceIds) {
    this.deviceType = deviceType;
    // On copie + trie les IDs pour un ordre chronologique stable
    this.deviceIds = [...(deviceIds || [])].sort((a, b) => a.localeCompare(b));
  }

  get baseName() {
    switch (this.deviceType) {
      case 'aquacheck':
        return 'Aquacheck';
      case 'greenwatch':
        return 'Greenwatch';
      case 'climatrack':
      default:
        return 'Climatrack';
    }
  }

  getAlias(deviceId) {
    if (!deviceId) return '';

    const index = this.deviceIds.indexOf(deviceId);
    if (index === -1) {
      return `${this.baseName} ?`;
    }

    // index + 1 → 1, 2, 3, ...
    return `${this.baseName} ${index + 1}`;
  }
}

// Helper fonctionnel optionnel si tu préfères une API fonctionnelle
export function getDeviceAlias(deviceType, deviceIds, deviceId) {
  const mapper = new DeviceNameMapper(deviceType, deviceIds);
  return mapper.getAlias(deviceId);
}
